export default __webpack_public_path__ + "static/media/Artwork.a2d41b8c.svg";